(function () {
    const PRODUCT_ID = document.querySelector('.variant-stock-toggle').dataset.productId;
    const INIT_FLAG = '__bbStockFilterInit_' + PRODUCT_ID;
    const FILTER_CLASS = 'filter-active';
    const ACTIVE_CLASS = 'active';
    const OOS_CLASS = 'is-out-of-stock';
    const TOGGLE_SEL = '.variant-stock-toggle[data-product-id="' + PRODUCT_ID + '"]';
    const UNAVAILABLE_SEL = '.product-option__label--unavailable';
    const PRODUCT_OPTIONS_SEL = '[data-product-options="' + PRODUCT_ID + '"]';

    function findOptionsRoot(toggleBtn) {
        return (
            (toggleBtn.closest && toggleBtn.closest('product-options')) ||
            document.querySelector(PRODUCT_OPTIONS_SEL)
        );
    }

    function isFilterOn(root) {
        return !!root && !!root.querySelector('.product-options__inputs.' + FILTER_CLASS);
    }

    function isOptionOutOfStock(optionEl) {
        if (!optionEl) return false;
        if (optionEl.getAttribute('data-is-in-stock') === 'false') return true;
        return !!optionEl.querySelector(UNAVAILABLE_SEL);
    }

    function isSelectedVariantOos(root) {
        if (!root) return false;
        const checked = root.querySelector('.product-option__input:checked');
        if (!checked) return false;
        const option = checked.closest && checked.closest('.product-option');
        return isOptionOutOfStock(option);
    }

    function markOutOfStock(root) {
        if (!root) return;
        root.querySelectorAll('.product-option--swatch').forEach(function (swatch) {
            swatch.classList.toggle(OOS_CLASS, isOptionOutOfStock(swatch));
        });
    }

    function ensureInStockSelected(root) {
        if (!root || !isSelectedVariantOos(root)) return;
        const swatches = root.querySelectorAll('.product-option--swatch');
        for (let i = 0; i < swatches.length; i++) {
            if (isOptionOutOfStock(swatches[i])) continue;
            const input = swatches[i].querySelector('.product-option__input');
            if (!input || input.checked) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            return;
        }
    }

    function syncMessageLabels(toggleBtn, on) {
        const allLabel = toggleBtn.querySelector('.stock-message__label--all');
        const filteredLabel = toggleBtn.querySelector('.stock-message__label--filtered');
        if (allLabel) allLabel.setAttribute('aria-hidden', on ? 'true' : 'false');
        if (filteredLabel) filteredLabel.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    function applyToToggle(toggleBtn, on) {
        const root = findOptionsRoot(toggleBtn);
        if (!root) return;
        if (on) {
            markOutOfStock(root);
            ensureInStockSelected(root);
        }
        root.querySelectorAll('.product-options__inputs').forEach(function (container) {
            container.classList.toggle(FILTER_CLASS, on);
        });
        toggleBtn.classList.toggle(ACTIVE_CLASS, on);
        toggleBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        syncMessageLabels(toggleBtn, on);
    }

    function syncForProduct(filterOn) {
        const root = document.querySelector(PRODUCT_OPTIONS_SEL);
        const toggleBtn = document.querySelector(TOGGLE_SEL);
        if (!root || !toggleBtn) return;

        markOutOfStock(root);

        if (typeof filterOn === 'boolean') {
            applyToToggle(toggleBtn, filterOn);
            return;
        }

        applyToToggle(toggleBtn, toggleBtn.classList.contains(ACTIVE_CLASS));
    }

    function setupOnce() {
        if (window[INIT_FLAG]) return;
        window[INIT_FLAG] = true;

        document.addEventListener('click', function (e) {
            const toggleBtn = e.target.closest && e.target.closest(TOGGLE_SEL);
            if (!toggleBtn) return;
            e.preventDefault();
            const root = findOptionsRoot(toggleBtn);
            if (!root) return;
            const turningOn = !isFilterOn(root);
            applyToToggle(toggleBtn, turningOn);
        });

        document.addEventListener('change', function (e) {
            if (!e.target.matches || !e.target.matches('[data-product-option]')) return;
            const root = e.target.closest && e.target.closest(PRODUCT_OPTIONS_SEL);
            if (!root) return;
            const toggleBtn = document.querySelector(TOGGLE_SEL);
            if (!toggleBtn) return;
            markOutOfStock(root);
            if (isFilterOn(root)) {
                ensureInStockSelected(root);
            }
        });

        const po = document.querySelector(PRODUCT_OPTIONS_SEL);
        const parent = po && po.parentNode;
        if (parent && typeof MutationObserver !== 'undefined') {
            const observer = new MutationObserver(function (mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    const added = mutations[i].addedNodes;
                    for (let j = 0; j < added.length; j++) {
                        const n = added[j];
                        if (n.nodeType === 1 && n.matches && n.matches(PRODUCT_OPTIONS_SEL)) {
                            syncForProduct();
                            return;
                        }
                    }
                }
            });
            observer.observe(parent, { childList: true });
        }
    }

    window.__bbVariantStockFilterSync = function (productId) {
        if (String(productId) !== String(PRODUCT_ID)) return;
        syncForProduct();
    };

    function init() {
        setupOnce();
        syncForProduct(false);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();